import { NoddiSelect } from '@ui-components/Inputs/NoddiSelect/NoddiSelect';
import { ComponentProps } from 'react';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type Props<TValue> = Omit<ComponentProps<typeof NoddiSelect<TValue>>, 'value' | 'onChange' | 'defaultValue'> & {
  onSelectionSideEffect?: (value: TValue) => void;
};

export const TanstackFormSelect = <TValue,>({ onSelectionSideEffect, ...rest }: Props<TValue>) => {
  const field = useFieldContext<TValue>();
  const fieldAria = useTanstackFieldAria(field, rest['aria-describedby']);

  return (
    <div>
      <NoddiSelect
        {...rest}
        id={rest.id ?? field.name}
        name={field.name}
        {...fieldAria}
        value={field.state.value}
        onChange={(value) => {
          field.handleChange(value as TValue);
          onSelectionSideEffect?.(value as TValue);
        }}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
